module.exports = __webpack_public_path__ + "static/img/loading.569057e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 1